<template>
  <div class="p-config-candidates">
    <Error v-if="hasError" variant="inline" size="sm">
      <template slot="title">
        ご指定いただいたキーワードでは安定的な順位を獲得できていないようです
      </template>
      <div class="c-text--free">
        <dl>
          <dt>＜考えられる原因＞</dt>
          <dd>
            <ul>
              <li>
                キーワードの検索ボリュームがあまりにも少ないためにSearch Console
                でも順位取得を不定期にしか行っていない。
              </li>
              <li>
                順位が低くユーザーに対しても検索結果画面として表示されていないため順位データが存在しない。
              </li>
            </ul>
          </dd>
        </dl>
      </div>
    </Error>
    <div v-else class="p-config-candidates__inner">
      <ListKeywordCandidates
        type="select"
        :checked="checked"
        :input="input"
        :items="items"
        :project="project"
        @change="change"
      />
      <ListKeywordCandidates
        v-if="input === 'checkbox'"
        type="selected"
        :checked="checked"
        :input="input"
        :items="items"
        :project="project"
        @change="change"
      />
    </div>
  </div>
</template>

<script>
import Error from '@/components/Error';
import ListKeywordCandidates from '@/components/config/ListKeywordCandidates';

export default {
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    checked: {
      type: [Array, Object],
      required: true
    },
    input: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    project: {
      type: Object,
      required: true
    }
  },
  components: {
    Error,
    ListKeywordCandidates
  },
  computed: {
    hasError() {
      return !this.items.length;
    }
  },
  methods: {
    change(checked) {
      this.$emit('change', checked);
    }
  }
};
</script>
